import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Paper, TableCell } from '@mui/material';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { endpoints } from '../../api/endpoints';
import { useContext, useState } from 'react';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { Actions } from '../../components/table/TableActions';
import { DeleteAlertModal } from '../../components/modal/DeleteAlertModal';
import { TablePagination } from '../../components/pagination/Pagination';
import { AppContext } from '../../contexts/AppContext';

export default function VendorListTable({ refetchData, loading, count, setSkip, setTake, take, skip, setIsView, setSelectedItem, setOpen, rows }: { refetchData: any, loading: any, take: any, skip: any, setSkip: any, setTake: any, count: any, setIsView: any, setOpen: any, setSelectedItem: any, rows: any }) {

  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [selectedId, setSelectedID] = useState<any | null>();
  const { user } = useContext(AppContext)

  const onSuccess = () => {
    setOpenAlertModal(false)
    setSelectedID(null)
    refetchData()
  }

  const onError = () => {
    setOpenAlertModal(false)
    setSelectedID(null)
  }

  const deleteAction = (row: any) => {
    setSelectedID(row.id);
    setOpenAlertModal(true)
  }

  const editAction = (row: any, isView?: boolean) => {
    setIsView(isView ? true : false)
    setSelectedItem(row)
    setOpen(true)
  }


  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell minwidth="10%">S.N</TableHeadCell>
                <TableHeadCell align="left" minwidth='80%'>Name</TableHeadCell>
                {
                  user && (user?.role)?.toLowerCase() === 'admin' ? <TableHeadCell align="center" minwidth="10%">Actions</TableHeadCell> : null
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {!rows || loading ? <TableRowsLoader rowsNum={5} colNum={3} />
                : rows.length <= 0 ? <TableRow><TableCell align="center" colSpan={3}>No data found</TableCell></TableRow>
                  : rows.map((row: any, index: number) => (
                    <TableRow
                      key={row.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell style={{ fontSize: "12px" }}>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                      <TableCell align="left" style={{ fontSize: "12px" }}>{row.vendorName}</TableCell>
                      {
                        user && (user?.role)?.toLowerCase() === 'admin' ? <TableCell align="center">
                          <Actions onDelete={deleteAction} onEdit={editAction} row={row} />
                        </TableCell> : null
                      }
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
        {rows && (rows?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
      </Paper>
      < DeleteAlertModal
        onSuccess={onSuccess}
        onError={onError}
        endpoint={endpoints.lockerVendor.delete}
        selectedId={selectedId}
        openAlertModal={openAlertModal}
        setOpenAlertModal={setOpenAlertModal}
      />
    </>
  );
}
